import React, { useEffect, useState } from 'react';
import { ArrowLeft, Crown, Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { formatTL, TIER_COLORS } from '@/lib/format';
import { useTokens } from '@/lib/theme';
import { Card, Empty } from '@/components/shared';

export default function Leaderboard() {
  const navigate = useNavigate();
  const tk = useTokens();
  const [view, setView] = useState('monthly');
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    const url = view === 'monthly' ? '/leaderboard/monthly' : '/leaderboard/yearly';
    api.get(url).then((r) => setData(r.data)).catch(() => {});
  }, [view]);

  const rows = data?.rows || [];

  return (
    <div className="px-5 py-6 fade-up" data-testid="leaderboard-page">
      <button onClick={() => navigate('/app/oduller')} className="flex items-center gap-1.5 text-navy/50 text-sm mb-4" data-testid="lb-back">
        <ArrowLeft strokeWidth={1.25} className="w-4 h-4" /> Geri
      </button>
      <h1 className="font-serif text-2xl text-navy mb-4">Sıralama</h1>

      <div className="flex gap-2 mb-5">
        {[['monthly', 'Bu Ay'], ['yearly', 'Yılın Mimarları']].map(([k, l]) => (
          <button key={k} onClick={() => setView(k)} data-testid={`lb-tab-${k}`}
            className={`px-4 py-2 rounded-full text-sm border transition-colors ${view === k ? 'bg-navy text-cream border-navy' : 'border-navy/20 text-navy/60'}`}>
            {l}
          </button>
        ))}
      </div>

      {!data ? <div className="text-navy/40 text-sm">Yükleniyor...</div> : rows.length === 0 ? <Empty text="Kayıt yok" /> : (
        <div className="space-y-2" data-testid="leaderboard-list">
          {rows.map((r) => (
            <Card key={r.architectId} className={`p-4 flex items-center justify-between ${r.isMe ? 'ring-1 ring-gold' : ''}`}>
              <div className="flex items-center gap-3">
                <span className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-medium shrink-0"
                  style={{ backgroundColor: r.rank <= 3 ? ['#A9793D', '#9CA3AF', '#CD7F32'][r.rank - 1] : tk.ink + '22', color: r.rank <= 3 ? '#FBF7F0' : tk.ink + '99' }}>
                  {r.rank}
                </span>
                <div>
                  <p className="text-sm text-navy font-medium flex items-center gap-1.5">
                    {r.name}
                    {r.vip && <Star strokeWidth={1.5} className="w-3.5 h-3.5 text-gold" />}
                    {r.isMe && <span className="text-[10px] text-gold">(Sen)</span>}
                    {view === 'yearly' && r.yearEnd && <Crown strokeWidth={1.5} className="w-3.5 h-3.5 text-gold" />}
                  </p>
                  <p className="text-xs" style={{ color: TIER_COLORS[r.tier] }}>{r.tier} · {r.city}</p>
                </div>
              </div>
              <span className="font-serif text-base text-navy">{formatTL(r.turnover)}</span>
            </Card>
          ))}
        </div>
      )}
      {view === 'yearly' && <p className="text-xs text-navy/50 mt-4">İlk 10 mimar (taç) yıl sonu ödülüne hak kazanır: tasarım turu + hediyeler.</p>}
    </div>
  );
}
